'use strict';

/**
 * @ngdoc service
 * @name gfcmsApp.stacktrace.service
 * @description
 * # stacktrace.service
 * Service in the gfcmsApp.
 */
angular.module('gfcmsApp')
  .factory('stacktraceService', function() {
    var service = {};
    service.print = printStackTrace;
    service.fromError = fromError;

    return service;

    function printStackTrace() {
      return StackTrace.get(); // jshint ignore: line
    }

    function fromError(error) {
      return StackTrace.fromError(error); // jshint ignore: line
    }
  });
